const stickyNav = document.querySelector('[data-education-center-sticky-nav]');

if (stickyNav) {
  const links = Array.from(stickyNav.querySelectorAll('[data-education-center-nav-link]'));
  const toggle = stickyNav.querySelector('[data-education-center-nav-toggle]');
  const panel = stickyNav.querySelector('[data-education-center-nav-panel]');
  const layout = stickyNav.closest('.education-center-layout');
  const mobileQuery = window.matchMedia('(max-width: 991.98px)');
  const sections = links
    .map((link) => {
      const id = link.getAttribute('href')?.replace(/^#/, '');
      return id ? document.getElementById(id) : null;
    })
    .filter(Boolean);

  let lockedActiveId = null;
  let lockTimeoutId = 0;

  document.body.classList.add('has-education-center-nav');

  // Shared offset for click scrolling and scroll-spy activation.
  const getScrollOffset = () => {
    const scrollPadding = Number.parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
    const scrollMargin = sections.reduce((max, section) => {
      const value = Number.parseFloat(getComputedStyle(section).scrollMarginTop) || 0;
      return Math.max(max, value);
    }, 0);

    return Math.max(scrollPadding, scrollMargin, 0);
  };

  const setActiveLink = (activeId) => {
    links.forEach((link) => {
      const isActive = link.getAttribute('href') === `#${activeId}`;
      link.classList.toggle('is-active', isActive);

      if (isActive) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  };

  const updateActiveFromScroll = () => {
    if (lockedActiveId) {
      setActiveLink(lockedActiveId);
      return;
    }

    const offset = getScrollOffset();
    const scrollBottom = window.scrollY + window.innerHeight;
    const docHeight = document.documentElement.scrollHeight;
    let activeId = sections[0]?.id;

    if (scrollBottom >= docHeight - 2) {
      activeId = sections[sections.length - 1]?.id;
    } else {
      sections.forEach((section) => {
        if (section.getBoundingClientRect().top <= offset + 1) {
          activeId = section.id;
        }
      });
    }

    if (activeId) {
      setActiveLink(activeId);
    }
  };

  const unlockActiveAfterScroll = () => {
    window.clearTimeout(lockTimeoutId);
    lockTimeoutId = window.setTimeout(() => {
      lockedActiveId = null;
      updateActiveFromScroll();
    }, 700);
  };

  const scrollToSection = (id) => {
    const section = document.getElementById(id);

    if (!section) {
      return;
    }

    const offset = getScrollOffset();
    const top = section.getBoundingClientRect().top + window.scrollY - offset;

    lockedActiveId = id;
    setActiveLink(id);
    window.scrollTo({
      top: Math.max(0, top),
      behavior: 'smooth',
    });
    history.pushState(null, '', `#${id}`);
    unlockActiveAfterScroll();
  };

  const syncPanel = () => {
    const collapsed = mobileQuery.matches && !stickyNav.classList.contains('is-open');

    if (panel && 'inert' in panel) {
      panel.inert = collapsed;
    }

    links.forEach((link) => {
      if (collapsed) {
        link.setAttribute('tabindex', '-1');
      } else {
        link.removeAttribute('tabindex');
      }
    });
  };

  const closeMenu = () => {
    stickyNav.classList.remove('is-open');

    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    }

    syncPanel();
  };

  const openMenu = () => {
    stickyNav.classList.add('is-open');

    if (toggle) {
      toggle.setAttribute('aria-expanded', 'true');
    }

    syncPanel();
  };

  const updateStuck = () => {
    if (!mobileQuery.matches) {
      stickyNav.classList.remove('is-stuck');
      closeMenu();
      return;
    }

    const layoutTop = layout ? layout.getBoundingClientRect().top : window.scrollY;
    const stuck = layoutTop < window.innerHeight * 0.55;
    stickyNav.classList.toggle('is-stuck', stuck);

    if (!stuck) {
      closeMenu();
    }
  };

  if (toggle) {
    toggle.addEventListener('click', () => {
      if (stickyNav.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });
  }

  document.addEventListener('click', (event) => {
    if (!stickyNav.contains(event.target)) {
      closeMenu();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeMenu();
    }
  });

  links.forEach((link) => {
    link.addEventListener('click', (event) => {
      const id = link.getAttribute('href')?.replace(/^#/, '');

      if (!id) {
        return;
      }

      event.preventDefault();
      scrollToSection(id);

      if (mobileQuery.matches) {
        closeMenu();
      }
    });
  });

  mobileQuery.addEventListener('change', () => {
    updateStuck();
    syncPanel();
  });

  window.addEventListener('scroll', () => {
    updateActiveFromScroll();
    updateStuck();
  }, { passive: true });
  window.addEventListener('resize', () => {
    updateActiveFromScroll();
    updateStuck();
  });

  if (window.location.hash) {
    const hashId = window.location.hash.replace(/^#/, '');

    if (sections.some((section) => section.id === hashId)) {
      // Defer so layout/sticky header measurements are ready.
      window.requestAnimationFrame(() => scrollToSection(hashId));
    }
  }

  updateActiveFromScroll();
  updateStuck();
  syncPanel();
}
